import { createContext } from "react";
import ReviewContextProps from "./models/ReviewContextProps";

const ReviewContext = createContext<ReviewContextProps>(
  {} as ReviewContextProps
);

export default ReviewContext;
